export default __webpack_public_path__ + "static/media/uff-logo-panel.1f37d9a7.png";